<template>
    <div class="gst-multi-value-cell">
        <div
            v-if="!expanded"
            class="d-inline-flex align-center">
            <span>{{ values[0] }}</span>
            <IconPlus
                v-if="hasSeveralValues"
                class="gst-multi-value-cell__toggle u-mouse-pointer flex-shrink-0 ml-1"
                @click="expanded = true" />
        </div>
        <template v-else>
            <div
                v-for="(value, index) in values"
                :key="index">
                {{ value }}
            </div>
            <IconMinus
                class="gst-multi-value-cell__toggle u-mouse-pointer mt-1"
                @click="expanded = false" />
        </template>
    </div>
</template>

<script>
import { IconMinus, IconPlus } from '@assets';

/*
 * Event / Attraction / Venue cells of the Campaigns grid (GAP-1430): one value shows in full;
 * several show the first with a "+" that lists them all, one per line, above a "−" that folds
 * them back, like the Customer Search Rate Id toggle. The column's autoHeight lets the row
 * follow.
 */
export default {
    name: 'MultiValueToggleCellRenderer',
    components: {
        IconMinus,
        IconPlus,
    },
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            expanded: false,
        };
    },
    computed: {
        values() {
            return Array.isArray(this.params.value) ? this.params.value : [];
        },
        hasSeveralValues() {
            return this.values.length > 1;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';

.gst-multi-value-cell {
    line-height: line-height('2xl');
    white-space: normal;
}
</style>
